import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ForgeSelect } from '@tylertech/forge-react';

import { I18n } from 'common/i18n';
import * as filters from 'common/components/AssetBrowser/actions/filters';
import { selectSource, selectSources } from 'common/components/AssetBrowser/selectors/filters';
import { AnyAction } from 'redux';

export const SourceFilter = () => {
  const source = useSelector(selectSource);
  const sources = useSelector(selectSources);
  const dispatch = useDispatch();

  const changeSource = (event: CustomEvent<HTMLInputElement>) => {
    const value = event.detail || null;
    dispatch((filters as any).changeSource(value));
  };

  const scope = 'shared.asset_browser.filters.source';

  const mappedSources = sources.map((source: string) => ({ label: source, value: source }));
  mappedSources.unshift({ label: I18n.t('options.all', { scope }), value: null });

  return (
    <div className="filter-section source">
      <label className="filter-label">{I18n.t('label', { scope })}</label>
      <ForgeSelect
        value={source || null}
        variant="filled"
        onChange={(event: CustomEvent<HTMLInputElement>) => changeSource(event)}
        placeholder={I18n.t('placeholder', { scope })}
        options={mappedSources}
      />
    </div>
  );
};

export default SourceFilter;
